import { lazy } from 'react';

import { ENV, isProductionApi } from '@pray/shared/config';

/**
 * C4: the second gate, independent of the toggle. The scenario layer only ever loads on a build
 * that does not talk to the production API, is not master, and only on a preview URL. Builds that
 * fail the first two conditions do not even contain it: craco swaps `dev/scenarios/*` for
 * `scenarioLayerStub` (see craco.config.js), and `check-master-build-scenarios` proves it in CI.
 */
export const isScenarioLayerAllowed = !isProductionApi && ENV !== 'master';

export const PREVIEW_PATH = '/preview/offer-funnel/:scenarioId/*';

export const isPreviewPath = (pathname: string) => pathname.startsWith('/preview/offer-funnel/');

export async function bootScenarioLayer(pathname: string): Promise<void> {
  if (!isScenarioLayerAllowed || !isPreviewPath(pathname)) return;
  const { installFromPath } = await import('dev/scenarios/install');
  installFromPath(pathname);
}

export const ScenarioPreviewApp = lazy(() => import('dev/scenarios/PreviewApp'));

export const FlowIndexRoute = lazy(() => import('dev/scenarios/FlowIndexRoute'));
